export var AssetLevel = /*#__PURE__*/function (AssetLevel) {
  // 环境依赖库 比如 react, react-dom
  AssetLevel[AssetLevel["Environment"] = 1] = "Environment";
  // 基础类库，比如 lodash deep fusion antd
  AssetLevel[AssetLevel["Library"] = 2] = "Library";
  // 主题
  AssetLevel[AssetLevel["Theme"] = 3] = "Theme";
  // 运行时
  AssetLevel[AssetLevel["Runtime"] = 4] = "Runtime";
  // 业务组件
  AssetLevel[AssetLevel["Components"] = 5] = "Components";
  // 应用 & 页面
  AssetLevel[AssetLevel["App"] = 6] = "App";
  return AssetLevel;
}({});
export var AssetLevels = [AssetLevel.Environment, AssetLevel.Library, AssetLevel.Theme, AssetLevel.Runtime, AssetLevel.Components, AssetLevel.App];
export var AssetType = /*#__PURE__*/function (AssetType) {
  AssetType["JSUrl"] = "jsUrl";
  AssetType["CSSUrl"] = "cssUrl";
  AssetType["CSSText"] = "cssText";
  AssetType["JSText"] = "jsText";
  AssetType["Bundle"] = "bundle";
  return AssetType;
}({});